module.exports = __webpack_public_path__ + "static/media/loader.5f97902d.svg";